import { Link } from '@remix-run/react'
import { ArrowRight } from 'lucide-react'
import { Button } from '~/components/ui/button'

export default function NothingFound404() {
    return (
        <div className='p-4 text-center w-full h-[70vh] font-semibold flex flex-col items-center justify-center'>
            <h1 className='text-9xl font-bold flex gap-1'>
                <span>4</span>
                <span
                    className='w-20 h-20 bg-companyRed rounded-full'
                    aria-hidden='true'
                ></span>
                <span className='sr-only'>0</span>
                <span>4</span>
            </h1>
            <h1 className='text-xl'>Page Not Found</h1>

            <p className='text-base font-normal mt-2'>
                We&apos;re sorry, we couldn&apos;t find the page you&apos;re
                looking for.
            </p>

            <Link to='/'>
                <Button className='mt-8 gap-2'>
                    Go back home
                    <ArrowRight />
                </Button>
            </Link>
        </div>
    )
}
